export default __webpack_public_path__ + "./image/c850c95d9b1fef11278ff34e9925915d.png";